"use strict";
Object.defineProperty(exports, "__esModule", {
    value: !0
});
var e = exports, r = {
    get BehaviorWithStore () {
        return a;
    },
    get ComponentWithStore () {
        return o;
    },
    get createStoreBindings () {
        return s;
    },
    get initStoreBindings () {
        return c;
    },
    get storeBindingsBehavior () {
        return u;
    }
};
for(var t in r)Object.defineProperty(e, t, {
    enumerable: !0,
    get: Object.getOwnPropertyDescriptor(r, t).get
});
require("miniprogram-api-typings");
var i = require("./behavior"), n = require("./core");
function o(e) {
    return Array.isArray(e.behaviors) || (e.behaviors = []), e.behaviors.unshift(i.behavior), Component(e);
}
function a(e) {
    return Array.isArray(e.behaviors) || (e.behaviors = []), e.behaviors.unshift(i.behavior), Behavior(e);
}
var s = function(e, r) {
    return (0, n.createActions)(e, r), (0, n.createDataFieldsReactions)(e, r);
}, u = i.behavior, c = function(e, r) {
    var t, i = e.self, o = e.lifetime;
    return o('attached', function() {
        (t = (0, n.createDataFieldsReactions)(i, r)).updateStoreBindings();
    }), o('detached', function() {
        t.destroyStoreBindings();
    }), {
        updateStoreBindings: function() {
            t && t.updateStoreBindings();
        }
    };
};
